export default __webpack_public_path__ + "static/media/avatar.df61a65b.svg";